import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories, sessionsUnlimitedCategory, sessionsPPACategory } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [
      this.current(sessionsUnlimitedCategory).require(basePlanCategories),
      this.current(sessionsPPACategory).require(basePlanCategories, { billingCycleMatch: false, licenseMatch: false }),
    ];
  }

  async conflicts() {
    return [
      ...[...sessionsUnlimitedCategory, ...sessionsPPACategory].map((c) => [c]),
      //todo UI restriction
      ...this.current(sessionsPPACategory).conflict(sessionsPPACategory),
      ...this.current(sessionsUnlimitedCategory).conflict(sessionsPPACategory),
    ];
  }
}
